module.exports = __webpack_public_path__ + "img/bnr_challenge_top_side_2_active.8bb7277f.png";